<template>
  <div v-if="loading.Data" class="d-flex flex-column h-100">
    <spinner-loading ></spinner-loading>
  </div>
  <div v-else class="d-flex flex-column h-100">
    <div class="content-header-card chart header-position">
      <div class="content-header-name d-flex justify-content-between w-100">
        <div>{{ renderData.card_name }}</div>
        <div >
          <img v-if="renderData.tooltip"
            :src="Tooltip"
            class="tooltip-img"
            v-b-tooltip.hover.bottomleft.html
            :title="renderData.tooltip"
          /> 
        </div>
      </div>
    </div>
    <div v-if="renderData.data.length > 0" class="content-body-card ">
      <div class="d-flex justify-content-center  body-gender-card">
        <div
          class="w-100"
          v-for="(item, index) in renderData.data"
          :key="item.title + index"
        >
          <div class="d-flex justify-content-center">
            <img 
              :src=resolveShowImg(index)
              class="d-flex justify-content-center gender-card-img"
            /> 
          </div>
          <div class="gender-card-title">
              {{ item.title }}
          </div>
          <div class="gender-card-percent"
            :class="[item.type]"
          >
              {{ item.percent }}
          </div> 
          <div class="summary-dashboard-unit">
            {{ formatter.format(item.value) +" "+ item.unit}}
          </div>
        </div>
      </div>
    </div>
    <div v-else class="content-body-card h-100">
      <card-no-item 
      :textNoImg="'Item Not Found'" 
      :height="100" 
      />
    </div>
  </div>
</template>

<script>
import store from "@/store";
import CardNoItem from "@core/components/card-no-item/CardNoItem.vue";

import NoGender from '@/assets/images/icons/NoGender.png';
import GenderMan from '@/assets/images/icons/GenderMan.png';
import GenderWoman from '@/assets/images/icons/GenderWoman.png';
import Tooltip from '@/assets/images/icons/Tooltip.png';

import {
  reactive,
  onMounted,
} from "@vue/composition-api";
import { formatter } from "@/utils/scripts/format-currency";
import { dynamicTableModel } from "@/models/data-management/dynamic-table";
import useValidationModal from "@/@core/components/base-modal/hooks/useValidationModal";

export default {
  components: {
    CardNoItem,
  },
  props: {
    configCard: Object,
    dataBi: { type: Array, default: () => [] },
    keyid: Object,
    dynamicTableConfig: Object,
    BrandAppDetail: Object,
  },
  setup(props) {
    const {
      openDefaultErrorModal,
    } = useValidationModal();

    const { fetchQueryDataModel } = dynamicTableModel();

    const loading = reactive({
      Data: false,
    });

    const renderData = reactive({
      card_name: "",
      keyid: "",
      tooltip: "",
      fields: [],
      data : []
    })

    const resolveShowImg = (seq) => {
      switch (seq) {
        case 0:
          return GenderWoman;
        case 1:
          return GenderMan;
        case 2:
          return NoGender;
      }
    };

    const fetchSummaryDetail = () => {
      loading.Data = true;

      const payload = {
        QueryData_Key: props.keyid.query_data_key,
        Query_Data_Key_Type: props.keyid.query_data_key_type,
        Display_Key: props.dynamicTableConfig.displayKey,
        Display_ChartId: props.keyid.display_chartid,
      };

      fetchQueryDataModel.payload = payload;

      store
        .dispatch("api/apiRequest", fetchQueryDataModel)
        .then((response) => {
          const respData = response.data.payload.find((o) => o.keyid == props.keyid.query_data_key);
          renderData.card_name = respData.card_name;
          renderData.keyid = respData.keyid;
          renderData.tooltip = respData.tooltip;
          renderData.fields = respData.fields;
          renderData.data = respData.data;
        })
        .catch((error) => {
          openDefaultErrorModal(error);
        })
        .finally(() => {
          loading.Data = false;
        });
    };

    onMounted(() => {
      fetchSummaryDetail();
    });

    return {
      loading,
      Tooltip,
      NoGender,
      GenderMan,
      GenderWoman,
      formatter,
      renderData,
      resolveShowImg,
    };
  },
};
</script>

<style>
@import "~@/assets/css/pages/data-management/summary-dashboard.css";

.body-gender-card {
  height: 120% !important;
  display: flex !important;
  align-items: flex-end !important;
}

.no-item-container {
  height: 100% !important;
}

.gender-card-title {
  text-align: center;
  font-size: 20px;
  color: rgb(0, 0, 0);
}

.gender-card-value {
  text-align: center;
  font-size: 20px;
  color: rgb(0, 0, 0);
}

.gender-card-percent {
  text-align: center;
  font-size: 30px;
  font-weight: bold;
  color: #000000 !important;
}

.gender-card-percent.woman {
  text-align: center;
  font-size: 30px;
  font-weight: bold;
  color: #ffcf01 !important;
}

.gender-card-img{
  height: 20%;
  width: 70%;
}

.header-position{
  padding: 1.5rem !important;
}

</style>
